
import { AsyncThunk, AsyncThunkConfig, createAsyncThunk } from "@reduxjs/toolkit";
import { Animal, GET_ANIMALS } from "../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/GQLCalls/getAnimalCall";
import { fetchByIdFactory } from "./fetchByIdFactory";
import { normalizeAnimalCorrection } from "../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/useAnimal";

  
export const fetchAnimalsByIdsThunk = createAsyncThunk(
  `animal/fetchByIds`,
  fetchByIdFactory<{animal: {info: Animal[]}}, Animal>(GET_ANIMALS, (animal) => animal.data.animal.info.map(normalizeAnimalCorrection))
) satisfies AsyncThunk<Animal[], number[], AsyncThunkConfig> as AsyncThunk<Animal[], number[], AsyncThunkConfig>
// Explicit typing is required

